import React, { useState } from 'react'
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';

export default function SmartAiContent({ img, video, id }) {
    const [loading, setLoading] = useState(true);

    const handleLoadedData = () => {
        setLoading(false);
    };

    const handleProgress = (state) => {

        if (state.playedSeconds > 0.001) {
            setLoading(false);
        }
    };
    const isMp4 = video?.includes('.mp4');

    const videoBlobs = useSelector((state) => state.videos.blobs);
    const blob = useSelector((state) => state.videos.blobs[id]);
    return (
        <div className='video-template-content' >

            {
                img &&
                <img
                style={{
                    // transform: "scale(1.02)",
                    position: "absolute",
                    top: '0',
                    left: '0',

                    width: "100%",
                    // height: "100%",
                    // objectFit: "cover",
                    zIndex: 1,
                    opacity: loading ? 1 : 0,
                    // transition: "opacity 0.2s",
                }}
                src={process.env.PUBLIC_URL + "/img/WEBP_Animation-static-preview/" + img} alt="" />
            }

            {video && blob &&

                isMp4 &&
                <video
                    // src={process.env.PUBLIC_URL + `/video/animation/${video}`}
                    style={{
                        // transform: "scale(1.02)",
                        // objectFit: 'contain',
                        width: "100%",
                        //  height: "100%",

                    }}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onLoadedData={() => setLoading(false)}
                >
                    <source src={URL.createObjectURL(blob)} type="video/mp4" />
                </video>

            }

        </div>
    )
}
